import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE_PHONE_DISPLAY, SITE_PHONE_TEL } from "../../config/site";

export default function CTASection({
  eyebrow = "Don't wait",
  title = "Get the help you deserve. Today.",
  description = "Insurance companies move fast. So should you. Free, confidential, no-obligation case review with an Indiana attorney within minutes.",
}) {
  return (
    <section className="section bg-bone-alt relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-48 -right-48 w-96 h-96 rounded-full bg-terracotta/20 blur-3xl"></div>
        <div className="absolute -bottom-48 -left-48 w-96 h-96 rounded-full bg-forest/20 blur-3xl"></div>
      </div>
      <div className="max-w-5xl mx-auto text-center relative">
        <div className="overline mb-3">{eyebrow}</div>
        <h2 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance">
          {title}
        </h2>
        <p className="text-base md:text-xl text-charcoal-soft max-w-2xl mx-auto leading-relaxed mb-9">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href={SITE_PHONE_TEL} className="btn-primary text-base md:text-lg py-4 px-8" data-testid="cta-call-button">
            <Phone className="w-5 h-5" /> Call {SITE_PHONE_DISPLAY}
          </a>
          <Link
            to="/contact"
            className="btn-ghost text-base md:text-lg py-4 px-8"
            data-testid="cta-form-button"
            data-attorney-contact="true"
            data-source="cta_section"
          >
            Get a Free Case Review
          </Link>
        </div>
        <div className="mt-6 text-xs text-charcoal-soft tracking-wider">
          AVAILABLE 24/7 · 100% CONFIDENTIAL · NO FEES UNLESS YOU WIN
        </div>
      </div>
    </section>
  );
}
